import {
  BuildingIcon,
  ChartLineIcon,
  LayoutDashboardIcon,
  LinkIcon,
  ListChecksIcon,
  NewspaperIcon,
  SendIcon,
  SideMenu,
  UserIcon,
} from '@fukuri-admins/ui/common';
import type { SideMenu as SideMenuItem } from '@fukuri-admins/ui/common/SideMenu/SideMenuNavigation/types';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

type Props = {
  imageUrl: string;
  displayName: string;
  clientName: string;
  signOut: () => void;
  enableMenus: {
    stressAssessment: boolean;
    clientNewsletter: boolean;
    userList: boolean;
    admins: boolean;
    branches: boolean;
  };
};

export const ClientSideMenuPresentations: React.FC<Props> = ({
  imageUrl,
  displayName,
  clientName,
  signOut,
  enableMenus,
}) => {
  const menus: SideMenuItem[] = [
    ...(enableMenus.userList
      ? [
          {
            icon: <UserIcon />,
            content: '利用者',
            link: ROUTES.USERS,
          },
        ]
      : []),
    {
      icon: <ChartLineIcon />,
      content: 'レポート',
      subMenus: [
        {
          content: '初回ログイン未完了者',
          link: ROUTES.PENDING_USERS,
        },
        {
          content: 'サービス利用履歴',
          link: ROUTES.SERVICE_REPORT,
        },
        {
          content: 'アプリ利用履歴',
          link: ROUTES.LOGIN_REPORT,
        },
      ],
    },
    ...(enableMenus.admins
      ? [
          {
            icon: <BuildingIcon />,
            content: '企業管理者',
            link: ROUTES.ADMINS.INDEX,
          },
        ]
      : []),
    ...(enableMenus.branches
      ? [
          {
            icon: <BuildingIcon />,
            content: '事業所',
            link: ROUTES.BRANCHES.INDEX,
          },
        ]
      : []),
    ...(enableMenus.stressAssessment
      ? [
          {
            icon: <ListChecksIcon />,
            content: 'ストレスチェック',
            link: ROUTES.STRESS_ASSESSMENTS.INDEX,
          },
        ]
      : []),
    ...(enableMenus.clientNewsletter
      ? [
          {
            icon: <NewspaperIcon />,
            content: '社内報',
            link: ROUTES.INTERNAL_NEWS.INDEX,
          },
        ]
      : []),
    {
      icon: <LinkIcon />,
      content: 'ポータル',
      link: ROUTES.PORTAL,
    },
    {
      icon: <LayoutDashboardIcon />,
      content: '利用方法',
      link: ROUTES.HOW_TO_USE,
      isExternal: true,
    },
    {
      icon: <SendIcon />,
      content: 'お問い合わせ',
      link: ROUTES.CONTACT,
      isExternal: true,
    },
  ];

  return (
    <SideMenu imageUrl={imageUrl} menus={menus} displayName={displayName} signOut={signOut}>
      <div className={styles.SideMenuFooter}>{clientName} 管理者</div>
    </SideMenu>
  );
};
